<div>
  <h4 class="mb-1">Pakketkeuze</h4>

  @if (showToSettings()) {
    <p class="paragraph-medium">Kies jouw niveau en schooljaar</p>
  } @else {
    <p class="paragraph-medium">
      Pas hier je pakketkeuze aan door je niveau of schooljaar te wijzigen.
    </p>
  }
</div>
<form (submit)="submit($event)">
  <div class="input-grid">
    <lyceo-form-field>
      <lyceo-form-label>Niveau</lyceo-form-label>
      <lyceo-select
        [searchable]="false"
        [items]="levels"
        placeholder="Selecteer niveau..."
        [formField]="form.level"
      />
    </lyceo-form-field>

    <lyceo-form-field>
      <lyceo-form-label>Schooljaar</lyceo-form-label>
      <lyceo-select
        [searchable]="false"
        [items]="filteredYears()"
        placeholder="Selecteer schooljaar..."
        [formField]="form.year"
      />
    </lyceo-form-field>
  </div>

  <button
    lyceoButton
    [block]="true"
    [disabled]="levelYearLoading() || form().invalid()"
    type="submit"
  >
    Opslaan
  </button>
</form>
